import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";

const AdoptionDetailsDrawerContent = ({
  lobAdoptionDecisions,
  closeDrawer,
}) => {
  return (
    <Box
      sx={{
        ml: "10px",
        mr: "5px",
      }}
    >
      {/* Title */}
      <Typography variant="h4" fontWeight="bold" mb={2} mt={2} ml={2}>
        Adoption Details
      </Typography>

      <Box>
        <Box sx={{ m: 2 }}>
          {lobAdoptionDecisions.map((lob) => (
            <Grid container key={lob.id} mb={2}>
              <Grid item size={4}>
                <Typography variant="body1" fontWeight="bold">
                  {lob.lobDesc + ":"}
                </Typography>
              </Grid>
              <Grid item size={8}>
                <Typography variant="body1">
                  <span>Adoption Decision:</span>{" "}
                  {lob.adoptionDecisionDesc
                    ? lob.adoptionDecisionDesc
                    : lob.adoptionDecision}
                </Typography>
                <Typography variant="body1">
                  <span>Effective Date:</span>{" "}
                  {lob.effectiveDate
                    ? dayjs(lob.effectiveDate).format("MM/DD/YYYY")
                    : "N/A"}
                </Typography>
                <Typography variant="body1">
                  <span>Variance Text:</span> {lob.varianceComments}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          minHeight: "70px",
          position: "absolute",
          bottom: "16px",
          right: "0",
        }}
      >
        <Button
          onClick={closeDrawer}
          variant="text"
          sx={{ fontWeight: "bold" }}
        >
          CLOSE
        </Button>
      </Box>
    </Box>
  );
};

export default AdoptionDetailsDrawerContent;
